import { render, staticRenderFns } from "./shopAftersaleTemplateEdit.vue?vue&type=template&id=64e57b72&"
import script from "./shopAftersaleTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./shopAftersaleTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./shopAftersaleTemplateEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports